// import React, {useState, useEffect } from 'react';
import React from 'react';
import Basemappage from './basemap_page';
import { useSelector } from 'react-redux';
import DateSlider from "../components/FormComopents/Form/DateSlider";
import {ControlButtons, 
        AnalaysisWindow,
        SideBarMenu,
        UserProjectWindow,
        NavigationWindow,
        UserFolioWindow,
        SearchWindow
      
      } from "../components/layout";
import {openMenu,
        openAnalysisWindow, 
        openUserProjectWindow, 
        openNavigationWindow, 
        openUserFolio,
        openSearch
      
      } from '../redux/actions/controlbuttonaction';

// import SerchVillage from 
// import SearchWindow from '../components/FormComopents/SearchWindow'

// import { useToken } from '../components/utils/useToken';
// import { Navigate } from "react-router-dom";
// import { IsAuthenticated } from '../components/utils/IsAuthticated';

function GlobeZoom() 
  {
const menuState =useSelector((state) => state.controlbutton.menubar)
const analysisWindowState =useSelector((state) => state.controlbutton.analysiswindow)
const userProjectWindowState = useSelector((state)=> state.controlbutton.userprojectwindow)
const navigationWindowState = useSelector((state)=> state.controlbutton.navigationwindow)
const userFolioState = useSelector(state=> state.controlbutton.userfoliodialog)
const searchWindowState =useSelector((state) => state.controlbutton.opensearch)
// const [authenticated, setAuthticated] = useState(null)
// useEffect(() => {
//       const loggedInUser = localStorage.getItem("user");
//     const isAuthenticated = loggedInUser.auth
//       if (isAuthenticated) {
//     setAuthticated(isAuthenticated);
//       }
//     }, []);

  return (
    <>
    <ControlButtons
    openMenu ={openMenu}
    openAnalysisWindow = {openAnalysisWindow}
    openUserProjectWindow = {openUserProjectWindow}
    openNavigationWindow = {openNavigationWindow}
    openUserFolio = {openUserFolio}
    openSearch = {openSearch}

    />
    {/* <SerchVillage/> */}
    <UserProjectWindow
      openUserProjectWindow={userProjectWindowState}
    />
    <SearchWindow
    openSearch= {searchWindowState}
    />
     <NavigationWindow
      openNavigationWindow={navigationWindowState}
    />
    
    <SideBarMenu
      menuOpen={menuState}
    />
    <DateSlider/>
     <AnalaysisWindow
      analysisWindowOpen={analysisWindowState}
    />
    <UserFolioWindow
    openUserFolio = {userFolioState}
    />
    <Basemappage/>
    </>
  );
 }

export default GlobeZoom;
